import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { appTicketsApi } from "../../services/api";

export const getTicketsList = createAsyncThunk("tickets/getTicketsList", async () => {
  try {
    const data = await appTicketsApi.getTickets();
    if (data.success) {
      return data.tickets;
    }
    return [];
  } catch (error) {
    console.error("Error fetching tickets:", error);
    return [];
  }
});

export const addNewTicket = createAsyncThunk("tickets/addNewTicket", async (ticket: any) => {
  try {
    const data = await appTicketsApi.createTicket({
      subject: ticket.title || ticket.subject,
      description: ticket.description,
      priority: ticket.priority || "medium",
      category: ticket.category || "general"
    });
    if (data.success) {
      toast.success("Ticket Added Successfully", { autoClose: 3000 });
      return { ...ticket, id: data.id };
    }
    throw new Error("Failed to add ticket");
  } catch (error) {
    toast.error("Ticket Added Failed", { autoClose: 3000 });
    return error;
  }
});

export const updateTicket = createAsyncThunk("tickets/updateTicket", async (ticket: any) => {
  try {
    const data = await appTicketsApi.updateTicket(ticket.id, {
      status: ticket.status,
      priority: ticket.priority,
      adminNotes: ticket.adminNotes
    });
    if (data.success) {
      toast.success("Ticket Updated Successfully", { autoClose: 3000 });
      return ticket;
    }
    throw new Error("Failed to update ticket");
  } catch (error) {
    toast.error("Ticket Updated Failed", { autoClose: 3000 });
    return error;
  }
});

export const deleteTicket = createAsyncThunk("tickets/deleteTicket", async (ticket: any) => {
  try {
    const data = await appTicketsApi.deleteTicket(ticket);
    if (data.success) {
      toast.success("Ticket Deleted Successfully", { autoClose: 3000 });
      return { ticket };
    }
    throw new Error("Failed to delete ticket");
  } catch (error) {
    toast.error("Ticket Delete Failed", { autoClose: 3000 });
    return error;
  }
});
